<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-header">Nouveau Colis</div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <form class="row" @submit.prevent="editColis">
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label for="can_open">Colis</label>
              <select
                class="form-control"
                id="can_open"
                v-model="colisData.can_open"
              >
                <option value="1">Ouvrir le colis</option>
                <option value="0">Ne pas ouvrir le colis</option>
              </select>
            </div>
          </div>
          <!--<div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label for="fragile">Fragile</label>
              <select
                class="form-control"
                id="fragile"
                v-model="colisData.fragile"
              >
                <option value="1">Oui</option>
                <option value="0">Non</option>
              </select>
            </div>
          </div> -->
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label for="replace">Colis Change</label>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="replace"
                  v-model="colisData.replace"
                  :true-value="1"
                  :false-value="0"
                />
                <label class="form-check-label" for="replace">
                  <span>Colis Change</span>
                  <span style="font-size: 12px">
                    <br />( Le colis sera remplacer avec l'ancien a la
                    livraison. )
                  </span>
                </label>
              </div>
              <div v-if="colisData.replace == 1" class="mt-2">
                <label class="form-label fw-medium text-black fs-13">Code du colis remplacé</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="colisData.code_replace"
                  @change="searchColis()"
                  placeholder="Code de suivi"
                />
                <small class="text-danger" v-if="existcolis">Ce colis n'existe pas</small>
                <small class="text-danger" v-if="replacecolis">Vous ne pouvez pas remplacer ce colis</small>
              </div>
            </div>
          </div>
          <div class="col-12">
            <hr />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="form-group">
              <label for="code">Code de suivi</label>
              <input
                type="text"
                class="form-control"
                id="code"
                v-model="colisData.code"
                placeholder="Code de suivi"
              />
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="form-group">
              <label for="dest">Destinataire</label>
              <input
                type="text"
                class="form-control"
                id="dest"
                v-model="colisData.receiver"
                placeholder="Destinataire"
                required
              />
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="form-group">
              <label for="phone">Numéro de téléphone *</label>
              <input
                type="text"
                class="form-control"
                @change="blackList(colisData.phone)"
                @input="validatePhone()"
                id="phone"
                v-model="colisData.phone"
                placeholder="0XXXXXXXXX"
                maxlength="10"
                pattern="0[0-9]{9}"
                required
                @keypress="if (isNaN(Number($event.key))) $event.preventDefault();"
              />
              <small class="text-danger" v-if="phoneError">
                Numéro invalide (doit commencer par 0 et contenir 10 chiffres)
              </small>
              <template v-if="!phoneError && error_blacklst.msg">
                <small class="text-danger" v-if="error_blacklst.msg == 'exist'">
                  Ce numéro est dans la black liste (
                  {{ error_blacklst.count }} fois)
                </small>
                <small
                  class="text-success"
                  v-if="error_blacklst.msg == 'not exist'"
                  >Ce numéro est sûr</small
                >
              </template>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="form-group">
              <label for="city">Ville</label>
              <v-select
                class="custom-select-height"
                id="city"
                required
                label="name"
                v-model="city"
                :options="citiesList"
                placeholder="Ville"
                @input="
                  GetFees(city);
                "
              />
            </div>
          </div>
                  
          <!-- GetQuartier(city);
          <div class="col-12 form-group mb-3">
            <label class="form-label fw-medium text-black" for="quartier"
              >Quartier</label
            >
            <v-select
              class="custom-select-height"
              id="quartier"
              label="name"
              :disabled="!city.id"
              v-model="quartier"
              :options="quartierList"
              placeholder="Quartier"
            />
          </div> -->
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label for="adresse">Adresse</label>
              <textarea
                class="form-control"
                id="adresse"
                v-model="colisData.address"
                rows="2"
                placeholder="Adresse"
                required
              ></textarea>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <div class="form-group">
              <label for="comment">Commentaire</label>
              <textarea
                class="form-control"
                id="comment"
                v-model="colisData.note"
                rows="2"
                placeholder="Commentaire"
              ></textarea>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label for="price">Prix</label>
              <input
                type="number"
                class="form-control"
                id="price"
                v-model="colisData.price"
                min="0"
                placeholder="Prix"
                required
              />
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
              <label for="product_nature">Nature Du Produit</label>
              <input
                type="text"
                class="form-control"
                id="product_nature"
                v-model="colisData.product_nature"
                placeholder="Nature Du Produit"
              />
            </div>
          </div>
          <div class="col-12 mb-3">
            <button type="submit" class="btn btn-primary float-right">
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useSanitize } from "@/composables/useSanitize";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { onMounted, reactive, ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true,
    },

    code: {
      type: String,
    },
  },

  setup(props) {
    // Import ref and reactive from Vue
    const { showToast } = useAppToast();
    const { sanitizeText } = useSanitize();

    const auth = useAuthStore();
    const user = auth.user;

    const citiesList = ref([]);
    const quartierList = ref([]);
    const city = reactive({ id: 0, name: null });
    const quartier = reactive({ id: 0, name: "" });
    const error = ref(false);
    const colisData = ref<any>({});
    const replace = ref(1);
    const existcolis = ref(false);
    const replacecolis = ref(false);
    const phoneError = ref(false);
    const error_blacklst = reactive({ msg: "", count: "" });

    const fees_livred_hors = ref(0);
    const fees_livred = ref(0);

    onMounted(async () => {
      try {
        const res = await api.get(`/api/auth/client/showColi`, {
          params: {
            id_parc: props.id,
            code: props.code,
          },
        });
        if (res.data.message == "not exist") {
          showToast("Colis n'existe pas", "error");
        } else if (res.data.message == "success") {
          city.id = res.data.data.city_id;
          city.name = res.data.data.city_name;
          quartier.id = res.data.data.quartier_id;
          Object.assign(colisData.value, res.data.data);
          console.log("colisData:", colisData.value);
          // If you have an OldPhone function, call it directly
            colisData.value.phone = oldPhone(colisData.value.phone);
          // this.$http.get(`/api/auth/client/QuartierList?city=${this.city.id}`).then(res => { this.QuartierList=res.data})
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      //   cities
      try {
        const res = await api.get(`/api/auth/client/citiesFees`);
        citiesList.value = res.data;
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    });

    function validatePhone() {
      const moroccanPhone = /^0[0-9]{9}$/;
      phoneError.value = !!colisData.value.phone && !moroccanPhone.test(colisData.value.phone);
    }

    async function searchColis() {
      existcolis.value = false;
      replacecolis.value = false;
      if (!colisData.value.code_replace) return;
      try {
        const data = new FormData();
        data.append("codesuivi", sanitizeText(colisData.value.code_replace));
        const res = await api.post(`/api/auth/client/ColisExist`, data);
        if (res.data === "not exist") existcolis.value = true;
        else if (res.data === "error status") replacecolis.value = true;
      } catch (error) {
        console.error("Erreur lors de la vérification du colis :", error);
      }
    }

    function editColis() {
      if (phoneError.value) {
        showToast("Numéro de téléphone invalide", "error");
        return;
      }
      if (colisData.value.price === '' || colisData.value.price === null || colisData.value.price === undefined) {
        showToast("Merci de saisir un prix", "error");
        return;
      }
      if (colisData.value.replace == 1 && (!colisData.value.code_replace || existcolis.value || replacecolis.value)) {
        showToast("Code de remplacement invalide ou manquant", "error");
        return;
      }

      let data = new FormData();
      data.append("code", colisData.value.code);
      data.append("address", colisData.value.address);
      data.append("note", colisData.value.note);
      data.append("receiver", colisData.value.receiver);
      data.append("phone", colisData.value.phone);
      data.append("city_name", city.name);
      data.append("city_id", city.id.toString());
      data.append("customer", colisData.value.customer);
      data.append("customer_name", colisData.value.customer_name);
      data.append("price", colisData.value.price);
      data.append("replace", colisData.value.replace);
      data.append("code_replace", sanitizeText(colisData.value.code_replace ?? ""));
      data.append("product_nature", colisData.value.product_nature);
      data.append("fragile", colisData.value.fragile);
      data.append("can_open", colisData.value.can_open);

      api
        .post(
          `/api/auth/client/coli_edit/${props.id}/${colisData.value.customer}`,
          data
        )
        .then((res: any) => {
          if (res.data.message == "success") {
            showToast("Les données sont bien sauvegardés", "success");
          } else if (res.data.message == "error status") {
            showToast("Vous pouvez pas supprimer ce colis", "error");
          } else if (res.data.message == "not exis") {
            showToast("Aucun coli trouvé", "error");
          }
        })
        .catch(() => {
          showToast("Something went wrong! Please try again", "error");
        });
    }

    function GetFees(city: any) {
      console.log(city);
      fees_livred_hors.value = city.delivered_fees || 0;
      fees_livred.value = city.delivered_same_city_fees || 0;
    }

    function blackList(phone: string) {
      //   const perms = JSON.parse(localStorage.getItem("PermsCstmr") || "{}");
      //   if (perms && perms.black_list == 1) {
      api
        .post(`/api/auth/client/blackList?phone=${phone}`)
        .then((response: any) => {
          if (response.data.msg != "no perms") {
            error_blacklst.msg = response.data.msg;
            error_blacklst.count = response.data.count;
          }
        });
      //   }
    }

    function GetQuartier(city: any) {
      api
        .get(`/api/auth/client/QuartierList?city=${city.id}`)
        .then((res: any) => {
          quartierList.value = res.data;
        });
    }

    function onSearchCities(search: string, loading: (v: boolean) => void) {
      if (search.length && citiesList.value.length == 0) {
        loading(true);
        api.get(`/api/auth/client/citiesFees`).then((res: any) => {
          citiesList.value = res.data;
          loading(false);
        });
      }
    }

    function oldPhone(val) {
      if(val && val!='' && val!=null){
        let phone = "";
        if (val.substring(0, 4) == "+212" && val.length == 13) {
          return "0" + val.slice(4);
        } else if (val.substring(0, 3) == "212" && val.length == 12) {
          phone = "0" + val.slice(2);
          return phone;
        } else if (val.substring(0, 1) == "0" && val.length == 10) {
          // phone = "+212" + val;
          return val;
        } else if (
          val.substring(0, 1) == "6" ||
          (val.substring(0, 1) == "7" && val.length == 9)
        ) {
          // phone = "+212" + val;
          return val;
        }  
      }else{
        return val;
      }
      
      // return val.substring(0,x);
    }

    return {
      citiesList,
      quartierList,
      city,
      quartier,
      error,
      colisData,
      replace,
      error_blacklst,

      editColis,
      GetFees,
      blackList,
      GetQuartier,
      onSearchCities,
      fees_livred_hors,
      fees_livred,
      auth,
      oldPhone,
      existcolis,
      replacecolis,
      phoneError,
      validatePhone,
      searchColis,
    };
  },
});
</script>

